import { InfoCircledIcon } from '@radix-ui/react-icons';
import { Card, Flex, Text } from '@radix-ui/themes';
import { CommonTooltip } from 'components/common/tooltip';
import { t } from 'i18next';
import { IStatsBarCard } from 'interfaces/session-recap/i-stats-bar-card';
import { StringHelper } from 'lib_ts/classes/string.helper';
import { RADIX, RadixTextSize } from 'lib_ts/enums/radix-ui';
import { PropsWithChildren } from 'react';
import './index.scss';

interface DataCardProps extends PropsWithChildren, IStatsBarCard {
  className?: string;
  /** Radix text steps; defaults match the shared card */
  titleSize?: RadixTextSize;
  valueSize?: RadixTextSize;
  unitSize?: RadixTextSize;
}

export const DataCard = ({
  className,
  title,
  value,
  unit,
  fallbackTooltip,
  titleSize = '2',
  valueSize = RADIX.TEXT.SIZE.LG,
  unitSize = RADIX.TEXT.SIZE.MD,
}: DataCardProps) => {
  return (
    <Card
      className={StringHelper.classNames(['DataCard', className])}
      variant="classic"
    >
      <Flex
        gap={RADIX.FLEX.GAP.XS}
        direction="column"
        justify="between"
        height="100%"
      >
        <Text color={RADIX.COLOR.SECONDARY} size={titleSize}>
          {t(title)}
        </Text>
        <Flex justify="between" align="center">
          <Flex gap={RADIX.FLEX.GAP.SM} align="end">
            <Text size={valueSize} weight="bold">
              {value}
            </Text>

            {!fallbackTooltip && unit && (
              <Text color={RADIX.COLOR.SECONDARY} size={unitSize} weight="bold">
                {unit}
              </Text>
            )}
          </Flex>

          {fallbackTooltip && (
            <CommonTooltip
              text={t(fallbackTooltip).toString()}
              trigger={<InfoCircledIcon />}
            />
          )}
        </Flex>
      </Flex>
    </Card>
  );
};
